import { assert_number_gte_0, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';

export abstract class DTODiffusionModelsTablePageBase<TItem extends DTO__base> extends DTO__base {
  /*
   * STATIC FIELDS
   */

  /*
   * FIELDS
   */

  items: TItem[];
  hash_crc32_settings_table!: string;
  hash_crc32_settings_table_page!: string;
  index!: number;

  /*
   * METHODS
   */
  constructor() {
    super();

    this.items = [];
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.hash_crc32_settings_table);
    assert_string_not_empty(this.hash_crc32_settings_table_page);
    assert_number_gte_0(this.index);
  }
}
